import { Injectable } from '@angular/core';
import { LoginDTO } from '../../models/login/loginDetails';
import { Dropdown } from '../../models/dropdown/dropdown';


@Injectable({
  providedIn: 'root'
})
export class LoginRenderingService {

  _login: LoginDTO;
  _dropdown: Dropdown;
  _emiError : any;
  currentUser: any;

  constructor() {
    this.login = new LoginDTO();
    this.dropdown = new Dropdown();
    this.emiError = new Object();
    this.currentUser ={};
  }

  public get login(): LoginDTO {
    return this._login;
  }

  public set login(value: LoginDTO) {
    this._login = value;
  }

  public get dropdown(): Dropdown {
    return this._dropdown;
  }

  public set dropdown(value: Dropdown) {
    this._dropdown = value;
  }

 public get emiError(): any {
    return this._emiError;
  }

  public set emiError(value: any) {
    this._emiError = value;
  }
}